import { ConditionForFetchHandler } from '../../cache-logic-interface';
import { conditionFetchForRoomMessageQuery } from './room-message-query-condition';

export let conditionFetchForDialogueMessageQuery: ConditionForFetchHandler =
  conditionFetchForRoomMessageQuery;
